import { CategoryChip, CategoryType, Typography } from '@abdoo/common';
import { SkeletonProps } from '@abdoo/common';
import { Box } from '@mui/material';
import React from 'react';

interface CategoryTotalProps extends SkeletonProps {
  categoryName: CategoryType;
  value: number;
  open: boolean;
  fontSize?: string;
}

export function CategoryTotal({
  categoryName,
  value,
  open,
  fontSize,
  isLoading,
  skeletonSx,
}: CategoryTotalProps) {
  const containerStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: fontSize ? fontSize : '0.8rem',
  };

  const categoryNameStyles = {
    display: undefined as string | undefined,
    transition: 'max-width 0.4s ease-in-out',
    maxWidth: '0em',
    overflow: 'hidden',
  };

  if (open) {
    categoryNameStyles.maxWidth = '6em';
  }

  return (
    <Box component="div" sx={containerStyles}>
      <CategoryChip categoryName={categoryName} value={value} isLoading={isLoading} />
      <Box component="span" sx={categoryNameStyles}>
        <Typography
          variant="body2"
          fontSize="0.8rem"
          fontWeight="bold"
          isLoading={isLoading}
          skeletonSx={{ width: '3rem', ...skeletonSx }}
        >
          {categoryName}
        </Typography>
      </Box>
    </Box>
  );
}
